module.exports = __webpack_public_path__ + "static/media/instagram-footer.9a609da0.svg";